import { defineComponent } from 'vue';
export default defineComponent({
    name: 'EnergyIndependenceBar',
    props: {
        energyIndependenceData: {
            type: Object,
            required: true,
        },
    },
});
